export default "__VITE_ASSET__c961b914__"